import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ReactComponent as ConfirmIcon } from '../../../assets/svg/ConfirmIcon.svg';
import { createNewKategorija, updateNewKategorija } from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import Loading from '../../../utils/Loading';
import VisibleCheckBox from '../common/VisibleCheckBox';

type Inputs = {
    naziv: string;
    opis: string;
    redosled: number | undefined;
};

function AddKategorijeModal({ modalIsOpen, closeModal, kategorija, reloadKategorije }: any) {
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(true);
    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        reset,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            naziv: '',
            opis: '',
            redosled: 0,
        },
    });

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root');
        }
    }, [modalIsOpen]);

    useEffect(() => {
        if (!!kategorija?.id) {
            setValue('naziv', kategorija.naziv);
            setValue('opis', kategorija.opis);
            setValue('redosled', kategorija.redosled);
            setVisible(kategorija?.visible);
        }
    }, [kategorija]);
    const onSubmit: SubmitHandler<Inputs> = async () => {
        if (!!kategorija?.id) updateKategorija();
        else {
            createKategorija();
        }
    };
    const createKategorija = async () => {
        setLoading(true);
        let data: any = getValues();
        data.redosled = getValues('redosled')?.toString();
        data.visible = visible;
        const resp = await createNewKategorija(data);
        if (resp.status == 201) {
            reloadKategorije();
            notif('Uspešno ste kreirali novu kategoriju');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };
    const updateKategorija = async () => {
        setLoading(true);
        let data: any = getValues();
        data.redosled = getValues('redosled')?.toString();
        data.visible = visible;
        data.id = kategorija?.id;
        const resp = await updateNewKategorija(data);
        if (resp.status == 201) {
            reloadKategorije();
            notif('Uspešno ste izmenili kategoriju');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };

    const changeVisibilty = () => {
        setVisible((prev) => !prev);
    };

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {
                reset();
            }}
            onRequestClose={closeModal}
            className="no-scroll"
            style={{
                overlay: {
                    zIndex: 5,
                    backdropFilter: 'brightness(30%)',
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 600,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    height: '100%',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'auto',
                    paddingTop: 15,
                    paddingBottom: 15,
                },
            }}
        >
            <div className="   max-h-[600px] w-full  ">
                <form
                    className="flex flex-col items-center w-full bg-white px-[40px] py-[30px] rounded-[10px]"
                    onSubmit={handleSubmit(onSubmit)}
                    autoComplete="off"
                >
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Naziv kategorije</label>
                        <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Naziv kategorije"
                                {...register('naziv', {
                                    validate: {
                                        najduze: (value) => value.length < 30,
                                        obavezno: (value) => value.length > 0,
                                    },
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.naziv?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''} </span>
                            <span>{errors.naziv?.type === 'najduze' ? 'Duzina ne sme prelaziti 30 karaktera' : ''}</span>
                        </p>
                    </div>
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Opis kategorije</label>
                        <div className="bg-white border border-black200 rounded-[4px] w-full px-3 py-2 flex flex-row items-center ">
                            <textarea
                                rows={6}
                                className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 orange-tiny-scroll"
                                placeholder="Opis kategorije"
                                {...register('opis', {
                                    validate: {
                                        najduze: (value) => value.length < 300,
                                        obavezno: (value) => value.length > 0,
                                    },
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.opis?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''} </span>
                            <span>{errors.opis?.type === 'najduze' ? 'Duzina nesme prelaziti 300 karaktera' : ''}</span>
                        </p>
                    </div>
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Redosled kategorije</label>
                        <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Redosled kategorije"
                                type="number"
                                {...register('redosled', {
                                    min: 0,
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px]  leading-5 h-5 ">
                            <span>{errors.redosled?.type === 'min' ? 'Vrednost mora biti pozitivan broj!' : ''} </span>
                        </p>
                    </div>
                    <VisibleCheckBox label="Kategorija vidljiva" value={visible} toggleValue={changeVisibilty} />
                    <p className="text-redError text-[12px] leading-5 h-5 ">{!!errorMessage ? errorMessage : ''}</p>
                    <div className="w-full flex flex-row gap-5 justify-end">
                        <button
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            onClick={(e) => {
                                e.preventDefault();
                                closeModal();
                            }}
                        >
                            <p>Otkaži</p>
                        </button>
                        <button
                            type="submit"
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            disabled={loading}
                        >
                            {loading ? (
                                <Loading size={25} />
                            ) : (
                                <div className="w-full flex flex-row items-center justify-center gap-3">
                                    <ConfirmIcon />
                                    <p>Potvrdi</p>
                                </div>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </ReactModal>
    );
}

export default AddKategorijeModal;
